import { object_map } from "@pdfking/rfunc"
import { Identity } from "@pdfking/tfunc"
import encode from "@pdfking/workflow/utils/encode"
export const DEFAULT_VIEW = "home"
export const NAV_VIEW = "menu"
export const SEARCH_VIEW = "search"
export const SLIDESHOW_VIEW = "slideshow"
export const MARKDOWN_VIEW = "markdown"
export const FILECHECK_VIEW = "filecheck"
export const PROMPT_VIEW = "prompt"

const query = (name, component) => ({
  component,
  name,
  navigate: query => ({
    name,
    query,
  }),
  path: `/${name}`,
  props: route => route.query,
})
const b64 = (name, component) => ({
  component,
  name,
  navigate: params => ({
    name,
    params: { b64: encode.dumps(params) },
  }),
  path: `/${name}/:b64`,
  props: route => encode.loads(route.params.b64),
})

const routes = [
  query(DEFAULT_VIEW, null),
  query(
    NAV_VIEW,
    () =>
      import(
        /* webpackChunkName: "navigation" */ "@pdfking/frontend/routes/views/nav"
      )
  ),
  query(
    SEARCH_VIEW,
    () =>
      import(
        /* webpackChunkName: "navigation" */ "@pdfking/frontend/routes/views/search"
      )
  ),
  b64(
    SLIDESHOW_VIEW,
    () =>
      import(
        /* webpackChunkName: "slideshow" */ "@pdfking/frontend/routes/views/slideshow"
      )
  ),
  b64(
    MARKDOWN_VIEW,
    () =>
      import(
        /* webpackChunkName: "markdown" */ "@pdfking/frontend/routes/views/markdown"
      )
  ),
  b64(
    FILECHECK_VIEW,
    () =>
      import(
        /* webpackChunkName: "filecheck" */ "@pdfking/frontend/routes/views/pdfview/pdfmodal"
      )
  ),
  b64(
    PROMPT_VIEW,
    () =>
      import(
        /* webpackChunkName: "prompt" */ "@pdfking/frontend/routes/views/prompt"
      )
  ),
]

export default object_map(p => p.name, Identity, routes)
